import { imageCtaStyles } from "@/design-system/Molecules/ImageCta/ImageCta.styles";
import { ImageCtaCard } from "@/design-system/Molecules";
import type { FC } from "react";

interface ImageCtaCardSectionProps {
  imageUrl?: string;
  heading?: string;
  description?: string;
  buttonText?: { text: string, to?: string, afterUpdateProfileText?: string };
  midCta?: boolean;
  className?: string;
}
export const ImageCtaCardSection: FC<ImageCtaCardSectionProps> = ({
  imageUrl,
  heading,
  description,
  buttonText,
  midCta = false,
  className,
}) => {
  return (
    <section
      className={`relative overflow-hidden mb-[-62px] md:px-auto 
        ${imageCtaStyles.imageCta} 
        ${imageCtaStyles.imageCtaBackground} 
        ${imageCtaStyles.imageCtaPadding}
        ${className}
        border-t-[12px] border-[#d1f99c]        
        `}
      style={{
        backgroundImage: `url(${imageUrl})`,
      }}
    >
      <div className="absolute inset-0 bg-[rgba(24,26,32,0.6)]" />

      <div className="container mx-auto px-3">
        <ImageCtaCard
          midCta={midCta}
          heading={heading}
          description={description}
          buttonText={buttonText}
        />
      </div>
    </section>
  );
};

export default ImageCtaCardSection;
